import {Api} from "../../api/Api"


/**
 *  Регистрция попытки доната
 */
export class RegisteringDonationAttempt {


    /**
     *  Регистрция попытки доната
     */
    async call({ sum, paymentType, title, comment }){
        const response = await Api.request( 'register_donation_attempt', {
            data: {
                sum:        sum,
                title:      title,
                comment:    comment,
                paymentType: paymentType
            }
        })
        console.log(response)
    }

}